import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { APP_CONFIG, defaultHeaders } from "../../../configs/config";
import { IconTokens } from "@voltmoney/schema";
import { ACTION } from "../loan_webView/types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { nextStepCredStepper } from "../../../configs/utils";
export const AgreementStatusAction = async (action, _datastore, { navigate, goBack, showPopup }) => {
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const getApiLoad = async () => {
        await fetch(`${api.agreementStatus}${applicationId}`, {
            headers: await defaultHeaders(),
        })
            .then((response) => response.json())
            .then(async (response) => {
            /// handle response
            if (response.stepResponseObject.toLowerCase() === "success") {
                clearInterval(timerRef);
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] = response.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                // await goBack();
                await showPopup({
                    type: "SUCCESS",
                    title: "Agreement submitted!",
                    subTitle: "Continue to setup AutoPay to make your interest payments automatically",
                    ctaLabel: "Go to AutoPay",
                    shouldAutoNavigate: true,
                    ctaAction: action,
                    isAutoTriggerCta: false,
                    primary: false
                });
            }
            else if (response.stepResponseObject.toLowerCase() === "failed") {
                clearInterval(timerRef);
                // await goBack();
                await navigate(ROUTE.ALERT_PAGE, {
                    alertProps: {
                        iconName: IconTokens.Failed,
                        title: "Agreement submit failed!",
                        subTitle: "Please try again",
                        type: "DEFAULT",
                        ctaLabel: "Continue to try again",
                        primary: true,
                        ctaAction: {
                            type: ACTION.GO_LOAN_AUTO_PAY,
                            routeId: ROUTE.LOAN_WEBVIEW,
                            payload: {},
                        },
                    },
                });
            }
        });
    };
    const timerRef = setInterval(() => {
        getApiLoad();
    }, APP_CONFIG.POLLING_INTERVAL);
};
export const GoNextSuccess = async (action, _datastore, { navigateWithClear }) => {
    // await goBack();
    const routeObj = await nextStepCredStepper();
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const GoNextFailed = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const GoBack = async (action, _datastore, { goBack }) => {
    goBack();
};
